import script from "./CityItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CityItem.vue?vue&type=script&setup=true&lang=js"

import "./CityItem.vue?vue&type=style&index=0&id=2525ed22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2525ed22"]])

export default __exports__